











































































import 'bootstrap';
import bootbox from 'bootbox';
import datefns from 'date-fns';
import binaryDownload from '@/services/BinaryDownloader';
import api from '@/services/api';
import { Component, Vue } from 'vue-property-decorator';

interface InjuryReportRequest {
    injuryDateStart: string;
    injuryDateEnd: string;
    reportType: string;
    studentOrEmployee: string;
    studentAccidentOnly: boolean;
}

@Component
export default class InjuryReport extends Vue {

    private searchInjuryDateStart: string = '';
    private searchInjuryDateEnd: string = '';
    private reportType: string = 'ALL';
    private studentOrEmployee: string = 'ALL';
    private studentAccidentOnly: boolean = false;

    get validDates(): boolean {
        const dRegex = /\d{4}-\d{2}-\d{2}/;

        if (!dRegex.test(this.searchInjuryDateStart) || !dRegex.test(this.searchInjuryDateEnd)) {
            return false;
        }

        const start = new Date(this.searchInjuryDateStart);
        start.setHours(0, 0, 0, 0);
        const end = new Date(this.searchInjuryDateEnd);
        end.setHours(23, 59, 59, 999);

        return datefns.isBefore(start, end);
    }

    private generateReport(): void {

        try {

            const criteria = this.getCriteria();

            binaryDownload('POST', '/api/v1/report/student_employee_injury', JSON.stringify(criteria));

        } catch (e) {
            bootbox.alert(e.message);
        }
    }

    private clearCriteria(): void {
        this.searchInjuryDateStart = '';
        this.searchInjuryDateEnd = '';
        this.reportType = 'ALL';
        this.studentOrEmployee = 'ALL';
        this.studentAccidentOnly = false;
    }

    private getCriteria(): InjuryReportRequest {
        if (!this.validDates) {
            throw new Error('Please enter the date range before running this report.');
        }

        return {
            injuryDateStart: this.searchInjuryDateStart,
            injuryDateEnd: this.searchInjuryDateEnd,
            reportType: this.reportType,
            studentOrEmployee: this.studentOrEmployee,
            studentAccidentOnly: this.studentAccidentOnly
        };
    }
}

